import React, { useRef, useState, useEffect, useLayoutEffect } from 'react'
import { gsap, MotionPathPlugin } from "gsap/all";
import {
  rootTwo,
  getDataFromCircularArray,
  getLimit,
  getPeople,
  describeArc,
} from './helpers';
import Star from './Star';
import './../App.css';

gsap.registerPlugin(MotionPathPlugin);


const Orbit = (props) => {

  const el = useRef();
  const q = gsap.utils.selector(el);

  const { innerWidth: screenWidth } = window;

  const radius = screenWidth / rootTwo;

  const center = {
    x: screenWidth / 2,
    y: radius,
  }

  const { frequency, data } = props;
  console.log(frequency, "data: ")
  console.log(data)
  const people = getPeople(data[frequency]);
  console.log(people);
  let limit = getLimit(frequency);

  const n = limit > people.length ? people.length : limit;

  const getNextIndices = ([currentA, currentB]) => {
    const a = (currentB === people.length ? 0 : currentB)
    let b = a + limit
    if (b > people.length) b = b - people.length
    return [a, b]
  }

  const getPreviousIndices = ([currentA, currentB]) => {
    let b = currentA
    let a = b - limit
    if (a < 0) a = people.length + a
    if (b === 0) b = people.length
    return [a, b]
  }

  const I = [0, limit > people.length ? people.length : limit]
  const nI = limit > people.length ? [0, people.length] : (
    [limit, limit * 2 <= people.length ? limit * 2 : limit - (people.length - limit)]
  )
  const pI = limit > people.length ? [0, people.length] : [people.length - limit, people.length]

  const [indices, setIndices] = useState({
    current: I,
    next: nI,
    previous: pI,
  });


  const [orbitState, setOrbitState] = useState({
    current: getDataFromCircularArray(people, I),
    next: getDataFromCircularArray(people, nI),
    previous: getDataFromCircularArray(people, pI),
  })

  const [actionsEnabled, setActionsEnabled] = useState(false);

  // const startingPoint = polarToCartesian(center.x, center.y, radius, -135);
  // const endingPoint = polarToCartesian(center.x, center.y, radius, 135);

  const next = () => {
    console.log("next");
    if (!actionsEnabled) return;
    setActionsEnabled(false);
    if (limit < people.length) {
      // todo: disable next and previous actions
      for (var i = 0; i < n; i++) {
        const r = (i + 1) / (n + 1)
        const prv = r * 0.33
        const cur = 0.33 + (r * 0.34)
        const nxt = 0.67 + (r * 0.33)
        gsap.to(q(`.orbiting-star-current-${i}`), {
          opacity: 0,
          duration: 1,
          repeat: 0,
          ease: "power1.inOut",
          motionPath: {
            path: `#${frequency}-orbit-path`,
            align: `#${frequency}-orbit-path`,
            alignOrigin: [0.5, 0.28],
            start: cur,
            end: nxt
          },
        });
        gsap.to(q(`.orbiting-star-next-${i}`), {
          opacity: 1,
          duration: 1,
          repeat: 0,
          ease: "power1.inOut",
          motionPath: {
            path: `#${frequency}-orbit-path`,
            align: `#${frequency}-orbit-path`,
            alignOrigin: [0.5, 0.28],
            start: prv,
            end: cur
          }
        });
        gsap.set(q(`.orbiting-star-previous-${i}`), {
          opacity: 0,
          motionPath: {
            path: `#${frequency}-orbit-path`,
            align: `#${frequency}-orbit-path`,
            alignOrigin: [0.5, 0.28],
            start: nxt,
            end: prv
          }
        });
      }
      setTimeout(() => {
        const i = getNextIndices(indices.current)
        const pI = [...indices.current]
        const nI = getNextIndices(i)
        console.log(i, nI, pI);
        setIndices({
          current: i,
          next: nI,
          previous: pI,
        });
      }, 1100);
    }
  }

  const previous = () => {
    if (!actionsEnabled) return;
    setActionsEnabled(false);
    if (limit < people.length) {
      // todo: disable next and previous actions
      for (var i = 0; i < n; i++) {
        const r = (i + 1) / (n + 1)
        const prv = r * 0.33
        const cur = 0.33 + (r * 0.34)
        const nxt = 0.67 + (r * 0.33)
        gsap.to(q(`.orbiting-star-current-${i}`), {
          opacity: 0,
          duration: 1,
          repeat: 0,
          ease: "power1.inOut",
          motionPath: {
            path: `#${frequency}-orbit-path`,
            align: `#${frequency}-orbit-path`,
            alignOrigin: [0.5, 0.28],
            start: cur,
            end: prv
          },
        });
        gsap.to(q(`.orbiting-star-previous-${i}`), {
          opacity: 1,
          duration: 1,
          repeat: 0,
          ease: "power1.inOut",
          motionPath: {
            path: `#${frequency}-orbit-path`,
            align: `#${frequency}-orbit-path`,
            alignOrigin: [0.5, 0.28],
            start: nxt,
            end: cur
          }
        });
        gsap.set(q(`.orbiting-star-next-${i}`), {
          opacity: 0,
          motionPath: {
            path: `#${frequency}-orbit-path`,
            align: `#${frequency}-orbit-path`,
            alignOrigin: [0.5, 0.28],
            start: prv,
            end: nxt
          }
        });
      }
      setTimeout(() => {
        const i = getPreviousIndices(indices.current)
        const nI = [...indices.current]
        const pI = getPreviousIndices(i)
        console.log(i, nI, pI);
        setIndices({
          current: i,
          next: nI,
          previous: pI,
        });
      }, 1100);
    }
  }

  useLayoutEffect(() => {
    console.log("Setup Layout")

    if (screenWidth > 500 && people.length > limit) {
      gsap.to(q(`.next-button`), {
        opacity: 1,
        duration: 1.3,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.5],
          start: 1,
          end: 0.65,
          autoRotate: true,
        },
      });
      gsap.to(q(`.prev-button`), {
        opacity: 1,
        duration: 1.3,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.5],
          start: 0,
          end: 0.35,
          autoRotate: true,
        },
      });
    } else {
      gsap.set(q(`.next-button`), { display: "none" })
      gsap.set(q(`.prev-button`), { display: "none" })
    }

    for (var i = 0; i < n; i++) {
      const r = (i + 1) / (n + 1)
      const prv = r * 0.33
      const cur = 0.33 + (r * 0.34)
      const nxt = 0.67 + (r * 0.33)

      gsap.to(q(`.orbiting-star-current-${i}`), {
        duration: 1,
        repeat: 0,
        ease: "power1.inOut",
        opacity: 1,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.28],
          start: 0,
          end: cur
        },
      });
      gsap.set(q(`.orbiting-star-next-${i}`), {
        opacity: 0,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.28],
          start: 0,
          end: nxt
        },
      });
      gsap.set(q(`.orbiting-star-previous-${i}`), {
        opacity: 0,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.28],
          start: 0,
          end: prv
        },
      });
    }
    setTimeout(() => {
      setActionsEnabled(true)
    })
  }, [])


  useEffect(() => {
    console.log("Reacting to indice change")
    setOrbitState({
      current: getDataFromCircularArray(people, indices.current),
      next: getDataFromCircularArray(people, indices.next),
      previous: getDataFromCircularArray(people, indices.previous),
    })
    setActionsEnabled(true);
  }, [indices]);


  useEffect(() => {
    console.log("Reacting to orbitState Change")
    for (var i = 0; i < n; i++) {
      const r = (i + 1) / (n + 1)
      const cur = 0.33 + (r * 0.34)
      gsap.set(q(`.orbiting-star-current-${i}`), {
        opacity: 1,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.28],
          start: 0,
          end: cur
        }
      });
      const prv = 0.67 + (r * 0.33)
      gsap.set(q(`.orbiting-star-previous-${i}`), {
        opacity: 0,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.28],
          start: 0,
          end: prv
        }
      });
      const nxt = (r * 0.33)
      gsap.set(q(`.orbiting-star-next-${i}`), {
        opacity: 0,
        motionPath: {
          path: `#${frequency}-orbit-path`,
          align: `#${frequency}-orbit-path`,
          alignOrigin: [0.5, 0.28],
          start: 0,
          end: nxt
        }
      });
    }
  }, [orbitState])

  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)

  // the required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50

  const onTouchStart = (e) => {
    setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX)
  }

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    const distance = touchStart - touchEnd
    const isLeftSwipe = distance > minSwipeDistance
    const isRightSwipe = distance < -minSwipeDistance
    if (isLeftSwipe || isRightSwipe) {
      console.log('swipe', isLeftSwipe ? 'left' : 'right')
      if (isLeftSwipe) previous()
      else next()
    }
  }


  return (
    <div ref={el} className={`orbit-container orbit-container-${frequency}`} onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}>
      <svg className="orbit-path" width={screenWidth * rootTwo} height={radius} xmlns="http://www.w3.org/2000/svg">
        <path id={`${frequency}-orbit-path`} d={describeArc(center.x - 1, center.y, radius, -135, 135)} stroke="white" fill="transparent" />
      </svg>
      {true && <div className="orbit">
        {orbitState.next.map((p, i) => <Star data={p} index={i} key={`next-${p.id}`} status="next" />)}
        {orbitState.current.map((p, i) => <Star data={p} index={i} key={`current-${p.id}`} status="current" onClick={() => { props.openOptions(p) }} />)}
        {orbitState.previous.map((p, i) => <Star data={p} index={i} key={`previous-${p.id}`} status="previous" />)}
      </div>
      }
      {false && <div className="debug-orbit-stats">
        <div>{people.length}</div>
        <div>{indices.previous}</div>
        <div>{indices.current}</div>
        <div>{indices.next}</div>
      </div>}
      <button className="prev-button" onClick={previous}><img src="/caret.png" alt="previous" /></button>
      <button className="next-button" onClick={next}><img src="/caret.png" alt="next" /></button>
    </div>
  );
}

export default Orbit;